<div class="activity-log-tab">
  <h6>Filter by</h6>
  <form [formGroup]="form">
    <!-- Filter By -->
    <div class="filter-by-row mb-4">
      <!-- Date -->
      <div
        name="daterangeInput"
        class="input-group date-filter"
        daterangepicker
        [options]="datePickerOptions"
        (applyDaterangepicker)="onFilterDate($event)"
        (cancelDaterangepicker)="onCancelFilterDate()"
        psUiActivityLog
      >
        <span class="form-control uneditable-input">
          <ng-container *ngIf="dates$ | async as date">
            {{ date.start | date : 'yyyy-MM-dd' }}
            {{ date.start && date.end ? ' - ' : 'Select date range' }}
            {{ date.end | date : 'yyyy-MM-dd' }}
          </ng-container>
        </span>
      </div>

      <!-- Project Status -->
      <ps-ui-select-dropdown
        id="select-with-search-icon"
        [dropdownItems]="status"
        [field]="'name'"
        [multi]="true"
        [idField]="'name'"
        labelNone="Survey Status"
        formControlName="status"
        [labelAlignment]="'start'"
        [loading]="false"
        [showClearStateButton]="true"
        clearStateButtonColor="gray"
      ></ps-ui-select-dropdown>

      <!-- Type of Activity -->
      <ps-ui-select-dropdown
        id="select-with-search-icon"
        [dropdownItems]="(categories$ | async) || []"
        [field]="'name'"
        [multi]="true"
        [idField]="'name'"
        labelNone="Activity Type"
        [labelAlignment]="'start'"
        [truncateWord]="false"
        [loading]="false"
        [showClearStateButton]="true"
        clearStateButtonColor="gray"
        formControlName="category"
      ></ps-ui-select-dropdown>

      <!-- Type of Feature -->
      <ps-ui-select-dropdown
        id="select-with-search-icon"
        [dropdownItems]="(features$ | async) || []"
        [field]="'name'"
        [multi]="true"
        [idField]="'name'"
        labelNone="Feature Type"
        [labelAlignment]="'start'"
        [truncateWord]="false"
        [loading]="false"
        [showClearStateButton]="true"
        clearStateButtonColor="gray"
        formControlName="feature"
      ></ps-ui-select-dropdown>

      <!-- Helth metrics -->
      <!-- <ps-ui-select-dropdown -->
      <!--   id="select-with-search-icon" -->
      <!--   [dropdownItems]="[]" -->
      <!--   [field]="'name'" -->
      <!--   labelNone="Helth metrics" -->
      <!--   [labelAlignment]="'start'" -->
      <!--   [loading]="false" -->
      <!-- ></ps-ui-select-dropdown> -->

      <!-- Project Manager -->
      <ps-ui-select-dropdown
        id="select-with-search-icon"
        [dropdownItems]="(users$ | async) || []"
        [field]="'name'"
        [multi]="true"
        [idField]="'name'"
        labelNone="Project manager"
        formControlName="user"
        [labelAlignment]="'start'"
        [truncateWord]="false"
        [loading]="false"
        [showClearStateButton]="true"
        clearStateButtonColor="gray"
      ></ps-ui-select-dropdown>

      <!-- User Type -->
      <ps-ui-select-dropdown
        id="select-with-search-icon"
        [dropdownItems]="userTypes"
        [field]="'name'"
        [multi]="true"
        [idField]="'name'"
        labelNone="User Type"
        formControlName="userType"
        [labelAlignment]="'start'"
        [truncateWord]="false"
        [loading]="false"
        [showClearStateButton]="true"
        clearStateButtonColor="gray"
      ></ps-ui-select-dropdown>
    </div>

    <!-- Search -->
    <section *ngIf="searchable">
      <h6>Search Activity</h6>
      <div class="search-activity-row mb-4">
        <input
          type="text"
          class="form-control survey-style"
          formControlName="message"
          placeholder="Search Activity"
        />
        <i class="fa fa-search"></i>
      </div>
    </section>
  </form>

  <div class="table table-responsive">
    <ps-ui-table [data]="(logs$ | async) || []" [trackBy]="'survey_id'">
      <!-- Activity -->
      <ng-container
        psUiTableColumn
        title="Message"
        [field]="'message'"
        [width]="'40%'"
      >
        <ng-template psUiTableColumnCustomHeader>
          <p class="title">Activity Message</p>
        </ng-template>
        <ng-template psUiTableCellTemplate let-option>
          <p class="no-margin no-padding">{{ option.message }}</p>
        </ng-template>
      </ng-container>

      <!-- Date -->
      <ng-container psUiTableColumn title="Date" [field]="'timestamp'">
        <ng-template psUiTableColumnCustomHeader>
          <p class="title title-date">
            Date
            <span class="help-message-tooltip">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
              <p>Time shows in your local time.</p>
            </span>
          </p>
        </ng-template>
        <ng-template psUiTableCellTemplate let-option>
          <p class="no-margin no-padding">{{ time(option.timestamp) }}</p>
        </ng-template>
      </ng-container>

      <!-- Survey Status -->
      <ng-container
        psUiTableColumn
        title="Survey Status"
        [field]="'survey_status'"
        [width]="120"
      >
        <ng-template psUiTableColumnCustomHeader>
          <p class="title title-status">Survey Status</p>
        </ng-template>
        <ng-template psUiTableCellTemplate let-option>
          <div class="no-margin no-padding">
            <ps-ui-survey-badge
              *ngIf="option.survey_status"
              [status]="option.survey_status"
            ></ps-ui-survey-badge>
          </div>
        </ng-template>
      </ng-container>

      <!-- User -->
      <ng-container psUiTableColumn title="User" [field]="'username'">
        <ng-template psUiTableColumnCustomHeader>
          <p class="title">User</p>
        </ng-template>
        <ng-template psUiTableCellTemplate let-option>
          <p class="no-margin no-padding">{{ option.username }}</p>
          <p class="no-margin no-padding subtitle">
            {{ userType(option.username) }}
          </p>
        </ng-template>
      </ng-container>

      <!-- Activity Type -->
      <ng-container psUiTableColumn title="Activity Type" [field]="'category'">
        <ng-template psUiTableColumnCustomHeader>
          <p class="title">Activity Type</p>
        </ng-template>
        <ng-template psUiTableCellTemplate let-option>
          <p class="no-margin no-padding">{{ option.category }}</p>
          <p class="no-margin no-padding subtitle">{{ option.feature }}</p>
        </ng-template>
      </ng-container>

      <!-- Notification -->
      <ng-container
        psUiTableColumn
        title="Notification"
        [field]="'notification'"
        *ngIf="notifications"
      >
        <ng-template psUiTableColumnCustomHeader>
          <p class="title text-center">
            <i class="fa fa-comments"></i>
          </p>
        </ng-template>
        <ng-template psUiTableCellTemplate let-option>
          <div
            class="notifications"
            *ngIf="option.notification_type === 'Email'"
          >
            <i class="fa fa-comments"></i>
            <a
              href="#"
              class="no-margin no-padding"
              (click)="onOpenNotificationsModal($event, option)"
            >
              See more
            </a>
          </div>
        </ng-template>
      </ng-container>

      <!-- No Data Message -->
      <ng-template psUiTableEmptyData>
        <p>{{ emptyTableMessage$ | async }}</p>
      </ng-template>
    </ps-ui-table>
  </div>
</div>
